import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import WinLossArchive from './components/WinLossArchive';
import NotificationCenter from './components/NotificationCenter';
import Reports from './components/Reports';

function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<WinLossArchive />} />
        <Route path="/notifications" element={<NotificationCenter />} />
        <Route path="/reports" element={<Reports />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;